import React, { Suspense } from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import Spline from "@splinetool/react-spline";

const HeroSpline = () => {
  const scrollToWork = () => {
    const element = document.getElementById("work");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen bg-black pt-20 overflow-hidden">
      {/* Stars background */}
      <div className="absolute inset-0 opacity-40">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.4) 1px, transparent 0)`,
            backgroundSize: "40px 40px",
          }}
        />
      </div>

      <div className="relative z-10 min-h-[calc(100vh-80px)] flex items-center">
        <div className="w-full px-[7.6923%] py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-[1400px] mx-auto">
            {/* Left side - Content */}
            <div className="space-y-8">
              <div className="space-y-6">
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-semibold leading-tight tracking-tight text-white">
                  Get yourself a website that actually works.
                </h1>
                <p className="text-xl md:text-2xl text-white text-opacity-85 leading-relaxed max-w-2xl">
                  We're a small, experienced team building fast, reliable
                  websites for local businesses.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <a
                  href="mailto:hello@frontroom.website"
                  className="bg-[#00FFD1] text-black px-6 py-4 text-lg font-medium transition-all duration-400 hover:bg-white hover:scale-[1.02] flex items-center justify-center gap-3 min-h-14"
                >
                  <span>hello@frontroom.website</span>
                  <ArrowRight size={22} />
                </a>
                <button
                  onClick={scrollToWork}
                  className="bg-white bg-opacity-10 text-white px-6 py-4 text-lg font-medium transition-all duration-400 hover:bg-white hover:text-black flex items-center justify-center gap-3 min-h-14 backdrop-blur-sm"
                >
                  See our work
                  <ArrowDown size={22} />
                </button>
              </div>
            </div>

            {/* Right side - Spline 3D */}
            <div className="relative h-[500px] lg:h-[700px] flex items-center justify-center">
              <div
                className="w-full h-full flex items-center justify-center"
                style={{ overflow: "visible", position: "relative" }}
              >
                <Suspense
                  fallback={
                    <div className="w-full h-full flex items-center justify-center">
                      <div className="w-16 h-16 border-4 border-[#00FFD1] border-t-transparent rounded-full animate-spin" />
                    </div>
                  }
                >
                  <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
                </Suspense>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown size={32} className="text-white text-opacity-40" />
      </div>
    </section>
  );
};

export default HeroSpline;
